'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Link } from '../link/link.js';

const BreadcrumbsLink = forwardRef(function BreadcrumbsLink(rest, ref) {
    return (jsx(Link, { suppressHydrationWarning // Since <ds-breadcrumbs> adds aria-current="page"
        : true, ref: ref, ...rest }));
});

export { BreadcrumbsLink };
